<template>
    <el-drawer
        :visible.sync="show"
        direction="btt"
        :before-close="handleClose"
        :destroy-on-close="true"
        :size="this.$tools.mainHeight() + 'px'"
    >
        <el-form ref="disForm" label-width="80px" :model="product" :rules="rules">
            <el-form-item label="1688链接" prop="url">
                <el-input v-model="item.url"></el-input>
            </el-form-item>

            <el-form-item label="cookie" prop="cookie">
                <el-input v-model="item.cookie"></el-input>
            </el-form-item>
        </el-form>
    </el-drawer>
</template>

<script>
export default {
    props: {
        show: { type: Boolean, default: false },
        isRoot: { type: Boolean, default: false },
    },

    data() {
        return {
            records: null,
            item: {},
        };
    },
    methods: {
        handleClose(done) {
            this.$emit("update:show", false);
            done();
        },
        reptile() {
            let _this = this;

            _this.$http.post(
                ["taobao/dis/reptile", {}],
                [
                    function (data) {
                        _this.item = data;
                    },
                ]
            );
        },
    },
};
</script>

<style lang="scss">
</style>